const expirationIsDefined = ({ expirationDate }) => !!expirationDate;
const isExpired = ({ expirationDate }) => expirationDate && expirationDate < new Date().toISOString();
const effectiveStartIsDefined = ({ effectiveStartDate }) => !!effectiveStartDate;
const isPremature = ({ effectiveStartDate }) => effectiveStartDate && effectiveStartDate > new Date().toISOString();
export const isInEffect = (term) => {
    let inEffect = true;
    if (expirationIsDefined(term))
        inEffect = !isExpired(term);
    if (effectiveStartIsDefined(term))
        inEffect = inEffect && !isPremature(term);
    return inEffect;
};
